import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import QuestionnaireItem from '../QuestionnaireItem';
import ValidationError from '../ValidationError';
import { Field } from 'redux-form';
import './styles.module.css';

export class QuestionnaireFieldCheckbox extends Component {
  renderInput(props) {
    const style = props.input.checked ? 'label checked' : 'label unchecked';
    const label = props.input.checked ? 'Completed' : 'Mark as Complete';
    const error = props.meta.error;

    return (
      <Fragment>
        {error && <ValidationError error={error} />}
        <label styleName={style}>
          <input {...props.input} styleName="input" type="checkbox" />
          {label}
        </label>
      </Fragment>
    );
  }

  render() {
    const { name, validate } = this.props;
    
    return (
      <QuestionnaireItem {...this.props}>
        <Field name={name} validate={validate} component={this.renderInput} type="checkbox" />
      </QuestionnaireItem>
    );
  }
}

QuestionnaireFieldCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  prompt: PropTypes.string,
  help: PropTypes.string,
  comments: PropTypes.bool,
  validate: PropTypes.func,
  links: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
};

export default QuestionnaireFieldCheckbox;